import React from "react";
import { getPastReservations } from "../../actions";
import Reservations from "./reservations";

const PastReservations = () => {
	return <Reservations reservationsLoader={getPastReservations} past />;
};

export default PastReservations;
